var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const SNAP_CANVAS = document.createElement("canvas");
export function pixelsToPNG(fileName, pixels, width, height) {
    return __awaiter(this, void 0, void 0, function* () {
        SNAP_CANVAS.width = width;
        SNAP_CANVAS.height = height;
        const context = SNAP_CANVAS.getContext("2d");
        if (!context)
            return undefined;
        const imageData = context.createImageData(width, height);
        imageData.data.set(pixels);
        const bitmap = yield createImageBitmap(imageData);
        context.scale(1, -1);
        context.drawImage(bitmap, 0, -height);
        const blob = yield new Promise((resolve) => {
            SNAP_CANVAS.toBlob(resolve);
        });
        if (!blob)
            return undefined;
        const file = new File([blob], fileName, { type: "image/png" });
        const url = URL.createObjectURL(file);
        return {
            url,
            file
        };
    });
}
